import { render } from "./EditQcm.vue?vue&type=template&id=9c1c6c22"
import script from "./EditQcm.vue?vue&type=script&lang=js"
export * from "./EditQcm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__